import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import VoxelMenuItemContainer from '../../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import HeadCell from '../../Shared/HeadCell';
import HeadCellStandardOptions from '../../Shared/HeadCellStandardOptions';
import { KeywordTableState } from '../logic/useKeywordTableState';
import { HeadCellImplementationProps } from './models';

export interface HeadCellArchiveTimeProps extends HeadCellImplementationProps {
  keywordTableState: KeywordTableState;
}

const HeadCellArchiveTime: React.FC<HeadCellArchiveTimeProps> = ({
  keywordTableState,
  basicConfig,
  basicState,
}) => {
  const { filterState, setFilterState } = keywordTableState;

  return (
    <HeadCell
      hasFilter={!!filterState.archiveTimeMax?.length || !!filterState.archiveTimeMin?.length}
      align={'left'}
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <div className="flex flex-col gap-2 px-2 pb-4 pt-0">
            <KeyboardDateTimePicker
              disableToolbar
              margin="dense"
              variant="inline"
              ampm={false}
              fullWidth
              mask="____-__-__ __:__"
              maskChar="_"
              placeholder="2022-05-30 22:00"
              format="yyyy-MM-dd HH:mm"
              value={filterState.archiveTimeMin ?? ''}
              onChange={(date, value) => {
                keywordTableState.setFilterState((prev) => ({
                  ...prev,
                  archiveTimeMin: date?.toISOString(),
                }));
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                size: 'small',
              }}
              label="Start time"
              InputLabelProps={{ shrink: true }}
              helperText={null}
              error={false}
            />
            <KeyboardDateTimePicker
              disableToolbar
              fullWidth
              margin="dense"
              mask="____-__-__ __:__"
              maskChar="_"
              variant="inline"
              placeholder="2022-05-30 22:00"
              format="yyyy-MM-dd HH:mm"
              ampm={false}
              value={filterState.archiveTimeMax ?? ''}
              onChange={(date, value) => {
                keywordTableState.setFilterState((prev) => ({
                  ...prev,
                  archiveTimeMax: date?.toISOString(),
                }));
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
                size: 'small',
              }}
              label="End time"
              InputLabelProps={{ shrink: true }}
              helperText={null}
              error={false}
            />
          </div>
        </MuiPickersUtilsProvider>
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellArchiveTime;
